import ArticleText from "../../components/articleText.component";
import ArticleImgs from "../../components/articleImgs.component";
import ArticleHeader from "../../components/articleHeader.component";
import NavBar from "../../components/navBar.component"

const ScrambledScreen = (props) => {
  const FOLDER = "2405CuillinRidge";

  const screen = {};

  return (<>
    <NavBar/>
    <div style={screen}>
      <ArticleHeader text="Scrambled" date="25.05.24" />
      <ArticleImgs folder={FOLDER} imgs={["thumbnail"]} />

      <ArticleText
        text={`Classic Rock is Ken Wilson's compilation of eighty timeless 
        rock climbs on the proudest mountain cliffs across Britain. Improbable, lower-grade routes 
        teasing their way up cracks and ledges to the summits of the most remote peaks in Snowdonia,
         the Lakes, the Highlands and on the Isle of Skye. Classic Rock sits on my coffee table, 
          double-spreads of crisp granite and 
         rhyolite gnawing at my patience with the City. The golden grain of colour-film photos from the 70s evokes such a painful 
         nostalgia. For a moment I'm with my brother, coiling ropes in the quietening evening sun and  
         watching the sun graze over the clumpy slopes of Moel Cynghorion.`}
      />

      <ArticleText
        text={`Page 264 is breath-taking. There are four specks of clashing primary 
        colour lost to a face so engulfing that neither the ground nor the sky are in frame. The climbers are 
        charting a line up a slab of two football fields. Above, cracks and roofs stack up and 
        off the page. The 900ft line in question takes in three routes back-to-back: Cioch Direct, 
        Arrow Route and Integrity. So where is this mighty cliff? In the remote south-westerly 
        corner of the Isle of Skye, and in the shadow of the Black Cuillin Ridge.`}
      />

      <ArticleImgs folder={FOLDER} imgs={["silouette"]} />

      <ArticleText
        text={`According to Ken the traverse of this ridge gives the best mountaineering
         excursion in Britain, in either summer or winter. It was not the first I'd heard of 
         the ridge. It's been on my winter hit list for a few years - good winter conditions 
         being hard to come by so far west in the North West. Mads and I came up with a wild
          plan. The route Integrity (the one with the huge slab pictured on my coffee table) tops out on the Cuillin Ridge; so why not do the first section of the ridge, 
          nip down to the base of Cioch Direct, regain the ridge via 900ft of other-worldly
           gabbro (the grippiest of black rock), and continue the famous scramble to the 
           Sligachan Hotel.`}
      />

      <ArticleText
        text={`The rest of this link-up was a train from London to Inverness, a 
        train from Inverness to Kyle of Lochalsh, a bus to Elgol and then a fishing boat to 
        the Coruisk Memorial Hut on Skye where our adventure would continue on foot. One night 
        above the route, another night on the ridge, back to hotel for a pint, then catch a 
        bus at 4pm.`}
      />

      <ArticleImgs folder={FOLDER} imgs={["ramp","boarding"]} />

      <ArticleText
        text={`To say that we underestimated this itinerary would be a gross 
        understatement.`}
      />

      <ArticleText
        text={`For starters the bus wasn't running. A taxi driver came to the rescue, twice. He got us to Elgol just in time, and then
          sorted a discounted crossing on his friends boat. Why? Because our booked crossing had 
          broken down. Upon hearing our itinerary the 
        taxi driver told us about his cousin Danny, who had ridden 
        the ridge on his bike. It was in fact not a pub tale, but a real account from Danny MacAskills cousin.`}
      />

      <ArticleText text={`On the boat the seal gazing day trippers had as little of an 
        idea about what we were in for as we did.`}/>

      <ArticleImgs folder={FOLDER} imgs={["boatheadshot", "seal"]} />

      <ArticleText
        text={`In the early afternoon we set off from the shore and soon scrambled ourselves into difficulty with an overly ambitious 
        route-finding decision. Needless to day we hadn't even reached Gars-bheinn - the first summit and the 
        start of the ridge. We roped up. Mads was frustrated and that alarmed me. Unplanned tying in should be a decision that always feels right, sort of bringing you together as a team. It's a question of safety, and when those questions are on the table, nothing else 
        matters and safer feels better. The other things come back onto 
        the table later and you can feel frustrated about them then. When we untied I was annoyed with myself for making the route finding error which had lead to us feeling a bit incompetent so early on in the trip. That being said I'm pleased about 
        every time I got nervous and reached for the rope over those three days on Skye.`}
      />

      <ArticleImgs folder={FOLDER} imgs={["3", "firstlookout"]} />

      <ArticleText
        text={`At the top of Gars-bheinn there was Soay, Egg and Rum. We were stunned and smiling and we were 
        worried about chewing what we had bitten off. Over our shoulders the whole of the dragons back was squashed into the frame. And though it didn't look that far, our legs did feel 895m above the beach and far, far from the boat meandering back to Elgol. So we scrambled on.`}
      />
      <ArticleImgs folder={FOLDER} imgs={["dragonsback"]} />


      <ArticleImgs folder={FOLDER} imgs={["abseil"]} />


      <ArticleImgs folder={FOLDER} imgs={["blurspoon","bivypuddle"]} />

      <ArticleImgs folder={FOLDER} imgs={["kings1","kings2"]} />
      <ArticleImgs folder={FOLDER} imgs={["kings3","kings4"]} />

      <ArticleImgs folder={FOLDER} imgs={["stonechute"]} />
      <ArticleImgs folder={FOLDER} imgs={["anstac"]} />
      <ArticleImgs folder={FOLDER} imgs={["pyramid","5"]} />
      
      <ArticleText text={`I've never experienced a richer sunset. A precious moment, and the kindest gift from the Cuillins. The stove was steaming and we sat amidst tufts of the greenest grass gorging on impossibly brief cosiness. It was a gift to have arrived at a place we could shelter for the night. A gift to be not 15 minutes later, and a gift for the rainstorm to wait just 15 minutes while the sun set. We dashed into our bivy bags as the first heavy drops clattered down in the fading, stil-pink light of a very, very long day.`} />

      <ArticleImgs folder={FOLDER} imgs={["6","cookingtogether"]} />

      <ArticleText text={`I can't remember when we came out of the clouds on that final day. We left our wet slot in the cliff shortly after 5am. Our improbable sunset sanctuary was gone, obliviously reclaimed by a thick fog and endless, blind mounds of greasy shale. Things happened between The Wart and  Sgùrr nan Gillean, in some order and none without considerable effort. 1. We got lost, 2. we realised that the compass, though inaccurate and unreliable (due to the exceptionally magnetic rock underfoot), was infact more accurate and reliable than GPS, 3. the Bazier Tooth is a terrifyingly imposing rock formation, 4. a pint in the pub is more important than summiting all of the munroes on the ridge. `} />
      <ArticleText text={``} />

      <ArticleImgs folder={FOLDER} imgs={["clouds"]} />
      <ArticleImgs folder={FOLDER} imgs={["pint"]} />
      <ArticleImgs folder={FOLDER} imgs={["1","2"]} />
    </div>
  </>);
};

export default ScrambledScreen;
